import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-web';
import animate from 'lottie-web';
import Typewriter from 'typewriter-effect';
import './Hero.css'
import { VANTA } from 'vanta';
import BIRDS from 'vanta/dist/vanta.net.min.js'

const Hero = () => {
  const container = useRef(null);


  const [vantaEffect, setVantaEffect] = useState(null);
  const myRef = useRef(null);
  VANTA.NET({
    el: "#app",
    mouseControls: true,
    touchControls: true,
    gyroControls: false,
    minHeight: 200.00,
    minWidth: 200.00,
    scale: 1.00,
    scaleMobile: 1.00,
    color: 0xff9500,
    backgroundColor: 0x0,
    points: 7.00,
    maxDistance: 15.00,
    spacing: 17.00
  })
  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(BIRDS({
        el: myRef.current
      }))
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy()
    }
  }, [vantaEffect])



  useEffect(() => {
    Lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('./astronaout.json'),
    });
    animate.setSpeed(.8);
  }, []);

  return (
    <section id='app' ref={myRef} className='section-bg pt-10'>

      <div style={{ height: '70vh' }} className=' mb-auto justify-center  items-center lg:flex flex-row-reverse px-5 space-y-5'>
        <div className='ml-auto mt-10 flex-1 w-48 md:w-96 lg:w-3/5'>
          <div className='container' ref={container}></div>
        </div>

        <p className='tracking-wide lg:text-3xl text-sm leading-relaxed flex-1'>
          <h1 className='text-2xl mt-4 font-bold md:text-5xl'>Hi , I'm Shakil Khan</h1>
          <div className='flex'>
            <h3 className='mr-2'>I'm</h3>
            <Typewriter
              options={{
                strings: ['Front-end developer...', 'Back-end Lover...', 'Daily learner...',],
                autoStart: true,
                loop: true,
              }}
            />
          </div>
        </p>
      </div>
    </section>
  );
};

export default Hero;
